export const i18n = {
    downloadStockList: {
        nl: 'Voorraadlijst downloaden',
        en: 'Download stock list',
        de: 'Vorratsliste herunterladen'
    },
    processing: {
        nl: 'Wordt verwerkt...',
        en: 'Processing...',
        de: 'Wird bearbeitet...'
    },
    login: {
        nl: 'Inloggen',
        en: 'Login',
        de: 'Anmelden'
    },
    logout: {
        nl: 'Uitloggen',
        en: 'Logout',
        de: 'Abmelden'
    },
    stock: {
        nl: 'Voorraad',
        en: 'Stock',
        de: 'Vorrat'
    },
    order: {
        nl: 'Bestelling',
        en: 'Order',
        de: 'Bestellung'
    },
    quotation: {
        nl: 'Offerte',
        en: 'Quotation',
        de: 'Anfrage',
    },
    placeOrder: {
        nl: 'Bestelling plaatsen',
        en: 'Place order',
        de: 'Bestellung aufgeben',
    },
    orderStart: {
        nl: 'Voeg eerst de soorten van uw keuze toe aan uw bestelling',
        en: 'First add the types of your choice to your order',
        de: 'Fügen Sie Ihrer Bestellung zunächst die Typen Ihrer Wahl hinzu',
    },
    orderSend: {
        nl: 'Bedankt voor uw aanvraag.<br>U krijgt binnen enkele minuten een e-mail met alle details van uw aanvraag.',
        en: 'Thank you for your request.<br>You will receive a confirmation e-mail with the details of your request details within a few minutes.',
        de: 'Vielen Dank für Ihre Anfrage.<br>Sie erhalten in wenigen Minuten eine E-Mail mit allen Details Ihrer Anfrage.',
    },
    label_companyName: {
        nl: 'Bedrijfsnaam',
        en: 'Company name',
        de: 'Firmenname',
    },
    label_contact: {
        nl: 'Contactpersoon',
        en: 'Contact person',
        de: 'Kontaktperson',
    },
    label_email: {
        nl: 'E-mailadres ',
        en: 'E-mail address',
        de: 'E-Mail Adresse ',
    },
    label_address: {
        nl: 'Adres ',
        en: 'Address',
        de: 'Adresse',
    },
    label_zipcode: {
        nl: 'Postcode ',
        en: 'Postal code',
        de: 'Postleitzahl',
    },
    label_city: {
        nl: 'Plaats ',
        en: 'City',
        de: 'Stadt',
    },
    label_country: {
        nl: 'Land ',
        en: 'Country',
        de: 'Land',
    },
    label_phone: {
        nl: 'Telefoon ',
        en: 'Phone',
        de: 'Telefonnummer',
    },
    label_request: {
        nl: 'Aanvraag ',
        en: 'Request',
        de: 'Anfrage',
    },
    label_order: {
        nl: 'Bestelling ',
        en: 'Order',
        de: 'Bestellung',
    },
    label_quotation: {
        nl: 'Offerte ',
        en: 'Quotation',
        de: 'Angebot',
    },
    label_delivery: {
        nl: 'Levering',
        en: 'Delivery',
        de: 'Lieferung',
    },
    label_at_request: {
        nl: 'Op afroep',
        en: 'At request',
        de: 'Abrufbereit',
    },
    label_direct: {
        nl: 'Direct',
        en: 'Directly',
        de: 'Sofort',
    },
    label_notes: {
        nl: 'Opmerkingen',
        en: 'Notes',
        de: 'Anmerkungen',
    },
    label_delivery_week: {
        nl: 'Gewenste leverweek',
        en: 'Desired delivery week',
        de: 'Gewünschte Lieferwoche ',
    },
    label_submit: {
        nl: 'Verzenden',
        en: 'Submit',
        de: 'Versenden',
    },
    label_required: {
        nl: 'Verplichte velden',
        en: 'Required fields',
        de: 'Erforderliche Felder',
    },
    label_quantity: {
        nl: 'Aantal',
        en: 'Quantity',
        de: 'Menge',
    },
    label_add: {
        nl: 'Toevoegen',
        en: 'Add',
        de: 'Hinzufügen',
    },
    label_cancel: {
        nl: 'Annuleren',
        en: 'Cancel',
        de: 'Abbrechen',
    },
    formError: {
        nl: 'Niet alle velden zijn correct ingevuld',
        en: 'Please make sure that you have filled in all fields correctly',
        de: 'Leider sind nicht alle Felder korrekt ausgefüllt',
    },
    error_companyName: {
        nl: 'Bedrijfsnaam is verplicht',
        en: 'Company name is required',
        de: 'Firmenname ist erforderlich',
    },
    error_contactName: {
        nl: 'Contactpersoon is verplicht',
        en: 'Contact person is required',
        de: 'Kontaktperson ist erforderlich',
    },
    error_email: {
        nl: 'Email is verplicht',
        en: 'E-mail address is required',
        de: 'E-Mail Adresse ist erforderlich',
    },
    error_request: {
        nl: 'Aanvraag is verplicht',
        en: 'Request is required',
        de: 'Anfrage ist erforderlich',
    },
    error_delivery: {
        nl: 'Levertijd is verplicht',
        en: 'Delivery is required',
        de: 'Lieferung ist erforderlich',
    },
    error_delivery_week: {
        nl: 'Leverweek is verplicht',
        en: 'Delivery week is required',
        de: 'Lieferwoche ist erforderlich',
    },
    account_request: {
        nl: 'vraag een account aan',
        en: 'request an account',
        de: 'fordern sie login daten an',
    },
    label_welcome: {
        nl: 'Welkom',
        en: 'Welcome',
        de: 'Wilkommen',
    },
    label_latest_update: {
        nl: 'Laatste update',
        en: 'latest update',
        de: 'Letzte Aktualisierung',
    },
    label_view_cart: {
        nl: 'Bestellen',
        en: 'Order',
        de: 'Bestellung',
    },
    label_view_stock: {
        nl: 'Voorraad',
        en: 'Stock',
        de: 'Lager',
    },
    cart_changed: {
        nl: 'Uw aanvraag is aangepast omdat de voorraad inmiddels is gewijzigd',
        en: 'Your request has been changed because the stock has been updated',
        de: 'Ihre Anfrage wurde geändert, weil der Vorat aktualisiert wurde.',
    },
    view_prices: {
        nl: 'om uw prijzen te kunnen zien of',
        en: 'to see your prices or',
        de: 'um Ihre Preise zu sehen oder',
    },
    login_to: {
        nl: 'Log in',
        en: 'Log in',
        de: 'Melden Sie sich an'
    },
    raise: {
        nl: 'Opslag',
        en: 'Raise',
        de: 'Zulage'
    },
    price: {
        nl: 'Prijs ',
        en: 'Price',
        de: 'Preis'
    },
    size: {
        nl: 'Potmaat ',
        en: 'Pot size',
        de: 'Topfgrsse'
    }
};